import { render, staticRenderFns } from "./proudce.vue?vue&type=template&id=5309ab2d&scoped=true&"
import script from "./proudce.vue?vue&type=script&lang=js&"
export * from "./proudce.vue?vue&type=script&lang=js&"
import style0 from "./proudce.vue?vue&type=style&index=0&id=5309ab2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309ab2d",
  null
  
)

export default component.exports